import Header from "./header";
import { Outlet } from "react-router-dom";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { Initializer } from "../initializer";
import Chatbot from "./chatbot";

const Layout = () => {
  const isLoading = useSelector((state: RootState) => state.user.loading)

  return (
    <Initializer>
      <div className="h-full flex flex-col">
        <Header />
        <main
          className="flex-1  text-primary"
          style={{ height: "calc(100% - 97px)" }}
        >
          <Outlet />
        </main>
        <Spin tip="Loading" spinning={isLoading} size="small" fullscreen >
        </Spin>
        <Chatbot />
      </div>
    </Initializer>
  );
};
export default Layout;
